import { ErrorState, LoadingSkeleton } from "../ui";
import { useNextT } from "../i18n";
import { useAccess } from "../access/api";
import { SwitchRoute } from "../routes/SwitchRoute";
import type { SwitchEntry } from "../routes/switchboard";
import { mapMode } from "./mapAccess";
import { NotForPlanners } from "./components/NotForPlanners";

/**
 * The guard of /map, aware of the switchboard (F4):
 *  - the new Map is served: it waits for the access answer; Plan routes opens the page (whatever the reach: it shows only what is in
 *    reach), everyone else reads board 120.10 with a way to Routes;
 *  - today's Map is served: exactly today's guard (`read_map`), which the switchboard's legacy side carries.
 * Both pages come from the switchboard line, so a flip of `mode` is the whole switch.
 */
export const MapRoute = ({ board }: { board?: SwitchEntry[] }) =>
  // Today's Map never asks the access model anything (no new request on that path).
  mapMode(board) === "next" ? <PlannerGuard board={board} /> : <SwitchRoute path="/map" board={board} />;

const PlannerGuard = ({ board }: { board?: SwitchEntry[] }) => {
  const { t } = useNextT();
  const { data, isLoading, error, refetch } = useAccess();
  if (error) return <div className="cy-next"><ErrorState title={t("map.access.failed_title")} body={t("map.access.failed_body")} onRetry={() => { void refetch?.(); }} /></div>;
  if (isLoading || !data) return <div className="cy-next"><LoadingSkeleton rows={4} label={t("map.access.loading")} /></div>;
  if (!data.permissions.includes("routes.plan")) return <NotForPlanners />;
  return <SwitchRoute path="/map" board={board} />;
};
